import { Route } from "react-router-dom";
import Protected from "../auth/Protected";
import ClientLayoutPage from "./layout";
import { UserRole } from "../../enums";
import ClientProfilePage from "./profile";

export default   <Route path="client"
            element={
              <Protected path="/client" roles={[UserRole.USER]}>
                <ClientLayoutPage />
              </Protected>
            }
          >
            <Route path="profile" element={<Protected path="/client/profile" roles={[UserRole.USER]}><ClientProfilePage /></Protected>} />
          </Route>